module.exports = {"id":"172077","name":"José María Basanta","rating":"74","photo":"./data/images/photos/1/172077.png","club":{"name":"Monterrey","logo":"./data/images/clubs/Monterrey.png"},"positions":["DC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JoseMariaBasanta0.json
// module id = 2176
// module chunks = 0